<template>
  <div class="bullseye">
    <div class="content" v-if="data && !$asyncComputed.data.error">
      <div class="left">
        <BullseyeDiagram
          v-model="internalSelection"
          :data="currentData"
          :showTooltip="true"
          :colorScale="currentColorScale"
          :instantUpdate="!doTransition"
        />
        <div class="legend" ref="legendContainer"></div>
      </div>
      <div class="controls">
        <multi-select-component
          label="variable"
          mode="single"
          v-model="_internalCurrentCol"
          :options="columnOptions"
          :configurationOptions="{'allow-empty': false, 'label-inside':true}"
        ></multi-select-component>
      </div>
    </div>
    <loading-overlay v-else-if="$asyncComputed.data.updating"></loading-overlay>
    <error-overlay v-else-if="$asyncComputed.data.error"></error-overlay>
  </div>
</template>

<script>
import BullseyeDiagram from '@/components/CaseDashboard/BullseyeDiagram'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import widgetContent from '@/mixins/widgetContent'
import Api from '@/api'
import d3 from '@/utils/d3importer'
import {formatValue} from '@/utils'
import legend from '@/utils/ColorLegend'
import {getColorScale} from '@/utils/colorScales'


export default {
  name: 'Bullseye',
  mixins: [widgetContent],
  props: ['currentTime','currentCol','currentSegment'],
  components: {
    BullseyeDiagram,
    MultiSelectComponent
  },
  data () {
    return {
      internalSelection: [],
      // currentCol: null,
      doTransition: false
    }
  },
  mounted () {
    
  },
  asyncComputed: {
    data () {    
      return Api.getSegments(this.$store.state.paramsData)
    }
  },
  methods:{
    drawLegend () {
      if(!this.currentCol) return
      let col = this.columnOptions.find((c)=>c.id === this.currentCol)
      let legendComp = legend({
        color: this.currentColorScale.nice(),
        title: col.label + (col.unit?` (${col.unit})`:''),
        ticks: 6,
        width: Math.min(320,this.$el.getBoundingClientRect().width*0.8),
        tickFormat: (d)=>formatValue(d)
      })
      // UN poco guarro no poder hacer "update"....pero no parece muy grabe de momento
      this.$refs.legendContainer.innerHTML = '';
      this.$refs.legendContainer.appendChild(legendComp)
    }
  },
  watch: {
    internalSelection(){
      console.log("internalSelection changed",this.internalSelection)
      if(this.internalSelection) this.$emit('change-segment',this.internalSelection[0])
    },
    columnOptions(){
      if(!this._internalCurrentCol) this._internalCurrentCol = this.columnOptions[0].id
    },
    currentCol(){
      this.doTransition = true
      this.$nextTick(()=>{
        this.doTransition = false
        this.drawLegend()
      })
    },
    size(){
      this.$nextTick(()=>{
        this.drawLegend()
      })
    },
    data () {
      this.$nextTick(()=>{
        this.drawLegend()
      })
    },
    currentSegment () {
      this.internalSelection = this.currentSegment?[this.currentSegment]:null
    }
  },
  computed:{
    _internalCurrentCol: {
      get () {
        return this.currentCol
      },
      set (value) {
        this.$emit('change-col',value)
      }
    },
    columnOptions () {
      if(!this.data) return []
      let headerOpts = this.data[0].segmentData.headers.map((h,i)=>{
        let unit = this.data[0].segmentData.units[i]
        return {
          value: h,
          id: h,
          label: h, //+ ` (${unit})`,
          unit: unit
        }
      })
      headerOpts.shift()
      return headerOpts
    },
    currentData () {
      
      // ESTA MAL DEL "idx" que no tiene en cuenta el total time1!!!!!
      
      let col = this.columnOptions.findIndex((c)=>c.id === this.currentCol)+1 //0=dt,1=strain,2=stress etc...
      let rows = this.data[0].segmentData.rows
      // let idx = Math.floor((rows.length-1)*this.currentTime)
      let idx = rows.findIndex((d)=>d[0] > this.currentTime) - 1
      if(idx<0) idx = 0
      let next = Math.min(idx+1,rows.length-1)
      // console.log("currentTime",this.currentTime)
      // console.log("next",next)
      let dt = rows[next][0] - rows[idx][0]
      let t = this.currentTime - dt*Math.floor(this.currentTime/dt)
      // console.log("idx",idx,"next",next,"t",t)
      return this.data.map((s)=>{
        let int = d3.interpolate(s.segmentData.rows[idx][col],s.segmentData.rows[next][col])
        let interpolated = int(t/dt)
        return {
          id: s.segmentId,
          value: interpolated,
          tooltipData: formatValue(interpolated)+' '+s.segmentData.units[col]
        }
      })
    },
    
    // CONNECTAR CON "utils.colorScales"!!!!
    currentColorScale () {
      // let domain = d3.extent(this.currentData,(d)=>d.value)
      let col = this.columnOptions.findIndex((c)=>c.id === this.currentCol)+1
      let segDomains = this.data.map((seg)=>d3.extent(seg.segmentData.rows.map((row)=>row[col]))).flat()
      let domain = d3.extent(segDomains)
      let scaleColor
      switch (this.currentCol){
        case 'V': scaleColor = "warm"; break;
        case 'Ca': scaleColor = "greens"; break;
        case 'K': scaleColor = "blues"; break;
        default: scaleColor = "warm"; break;
      }
      // return d3.scaleSequential(scale).domain(domain)
      let scale = getColorScale(scaleColor)
      scale.domain(domain)
      return scale
    }
  }
}
</script>

<style scoped lang="stylus">
.bullseye
  background: #fff
  overflow: visible !important
  position: relative

  .content
    display: flex
    height: 100%
    position: absolute
    width: 100%

    .left
      display: flex
      flex: 1 1 auto
      flex-direction: column
      overflow: hidden

      .bullseye-diagram
        flex: 1 1 auto
        overflow: hidden

        svg
          user-select: none

          .cell
            cursor: pointer
            transition: opacity 0.3s

            text
              fill: #000
              font-size: 20px

            &.highlighted
              stroke: #444

            &.unhighlighted
              opacity: 0.2

      .legend
        padding: 10px

        >>>svg
          margin: auto

    .controls
      align-items: flex-end
      display: flex
      flex: 0 0 auto
      flex-wrap: wrap
      justify-content: flex-end
      max-width: 100%
      position: absolute
      right: 60px
      transform: translate(0, -47px) // GUARRO GUARRO.... :D
      z-index: 2

      .multi-select-component
        margin: 0 5px
</style>